import React from 'react';

import { useOnlineBookingReducer } from '../../state/useOnlineBookingReducer';

import { PaymentStep } from './PaymentStep';
import { PaymentStepPreview } from './PaymentStepPreview';

export const PaymentStepWrapper = () => {
  const {
    state: { initParams },
  } = useOnlineBookingReducer();
  if (initParams?.source === 'preview') {
    return <PaymentStepPreview />;
  }
  return <PaymentStep />;
};
